import React, { type FC, memo, useMemo } from "react";
import { Alert } from "@heroui/react";
import { FormattedMessage } from "react-intl";
import { type GQL } from "@binale-tech/shared";

type FinApiResultAlertProps = {
    result?: GQL.IFinApiTransactionsImportResponse;
    error?: string;
};

const FinApiResultAlertImpl: FC<FinApiResultAlertProps> = ({ result, error }) => {
    const processedValues = useMemo(() => ({ count: result?.transactionsCount }), [result?.transactionsCount]);
    const timeframeValues = useMemo(
        () => ({ from: result?.transactionsDateFrom, to: result?.transactionsDateTo }),
        [result?.transactionsDateFrom, result?.transactionsDateTo],
    );

    if (error) {
        return (
            <Alert color="danger" className="w-full">
                {error}
            </Alert>
        );
    }

    if (result) {
        return (
            <Alert color="success" className="w-full">
                <div className="flex flex-col gap-2">
                    <div>
                        <FormattedMessage id="app.banks.transactionsProcessed" values={processedValues} />
                    </div>
                    {result.transactionsCount > 0 && (
                        <div>
                            <FormattedMessage id="app.banks.transactionsTimeframe" values={timeframeValues} />
                        </div>
                    )}
                </div>
            </Alert>
        );
    }

    return null;
};

export const FinApiResultAlert = memo(FinApiResultAlertImpl);
